import gql from 'graphql-tag'
export const tagFragment = gql`
    fragment tagFragment on Tag{
        id
        name
        shortname
        type
        isForeman
        deleted_at
    }
`

export const ratedTagFragment = gql`
    fragment ratedTagFragment on Tag{
        id
        name
        shortname
        pivot {
            rating
            user_profile_id
            tag_id
        }
        type
    }
`

export const customTagFragment = gql`
    fragment customTagFragment on CustomTag{
        id
        customtag_label_id
        name
        shortname
        type
        deleted_at
        label {
            id
            name
        }
    }
`

export const customTagLabelFragment = gql`
    fragment customTagLabelFragment on Customtag_label{
        id
        name
        applyTo
        deleted_at
    }
`